import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NewMessage = _resolveComponent("NewMessage")
  const _component_NcDialog = _resolveComponent("NcDialog")

  return (_openBlock(), _createBlock(_component_NcDialog, {
    ref: "dialog",
    name: $props.dialogTitle,
    "close-on-click-outside": "",
    size: "normal",
    "onUpdate:open": _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_NewMessage, {
        ref: "newMessage",
        role: "region",
        class: "send-message-dialog",
        token: $props.token,
        container: $data.modalContainerId,
        "aria-label": $props.dialogTitle,
        dialog: "",
        broadcast: $props.broadcast,
        onSubmit: $options.handleSubmit
      }, null, 8, ["token", "container", "aria-label", "broadcast", "onSubmit"])
    ]),
    _: 1
  }, 8, ["name"]))
}